var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.44394 6.669C1.1091 6.76467 0.805039 6.94612 0.561851 7.19538C0.318663 7.44465 0.144775 7.75309 0.0573935 8.09019C-0.0299883 8.42729 -0.0278354 8.78137 0.0636392 9.11739C0.155114 9.4534 0.33274 9.75971 0.578941 10.006L3.99094 13.414V20H10.5839L14.0189 23.43C14.2033 23.6159 14.4226 23.7636 14.6642 23.8645C14.9059 23.9654 15.1651 24.0176 15.4269 24.018C15.599 24.0177 15.7704 23.9955 15.9369 23.952C16.2739 23.8671 16.5826 23.695 16.8318 23.4529C17.0811 23.2108 17.2622 22.9073 17.3569 22.573L23.9909 0.0209961L1.44394 6.669ZM1.99994 8.592L19.0279 3.572L5.99294 16.586V12.586L1.99994 8.592ZM15.4399 22.016L11.4129 18H7.41294L20.4459 4.978L15.4399 22.016Z",
    fill: "#0085FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlain);
export default __webpack_public_path__ + "static/media/paperPlain.32f289d15a4e9e8306977cfb77a8150b.svg";
export { ForwardRef as ReactComponent };